<script>
  let { size = 48, fill = "black" } = $props();
</script>

<svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M30 36H1C0.447715 36 0 35.5523 0 35V32C0 31.4477 0.447715 31 1 31H30V36ZM47 31C47.5523 31 48 31.4477 48 32V35C48 35.5523 47.5523 36 47 36L41 36V31L47 31Z"
    {fill}
  />
  <path
    d="M39 33.5C39 31.567 37.433 30 35.5 30C33.567 30 32 31.567 32 33.5C32 35.433 33.567 37 35.5 37V40C31.9101 40 29 37.0899 29 33.5C29 29.9101 31.9101 27 35.5 27C39.0899 27 42 29.9101 42 33.5C42 37.0899 39.0899 40 35.5 40V37C37.433 37 39 35.433 39 33.5Z"
    {fill}
  />
  <path
    d="M16 14.5C16 12.567 14.433 11 12.5 11C10.567 11 9 12.567 9 14.5C9 16.433 10.567 18 12.5 18V21C8.91015 21 6 18.0899 6 14.5C6 10.9101 8.91015 8 12.5 8C16.0899 8 19 10.9101 19 14.5C19 18.0899 16.0899 21 12.5 21V18C14.433 18 16 16.433 16 14.5Z"
    {fill}
  />
  <path
    d="M7 17H1C0.447715 17 0 16.5523 0 16V13C0 12.4477 0.447715 12 1 12H7V17ZM47 12C47.5523 12 48 12.4477 48 13V16C48 16.5523 47.5523 17 47 17H17.5V12H47Z"
    {fill}
  />
</svg>
